import React, { useState } from 'react';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Link } from '@uhg-abyss/web/ui/Link';
import { event } from '@uhg-abyss/web/tools/event/event';

export const GoldCardAlert = () => {
  const { getHomePageContentByKey, getMessage } = usePPDLagoon();
  const [isAlertVisible, setIsAlertVisible] = useState(true);
  const alertmessage = getMessage('gold-card-status-available-alert');
  const goldCardInfo = getHomePageContentByKey('goldCardStatusByTaxID');

  const StyledAlert = styled('div', {
    marginBottom: '10px',
  });

  const StyledPara = styled('p', {
    marginBottom: '0px',
  });

  return (
    <StyledAlert>
      <Alert
        title='Gold Card qualification status is now available.'
        variant='warning'
        isVisible={isAlertVisible}
        onClose={() => {
          setIsAlertVisible(false);
        }}
      >
        <StyledPara>{alertmessage}</StyledPara>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          data-testid='goldCardStatusByTaxID'
          fontWeight='bold'
          onClick={() => {
            event('EXIT_LINK_NAVIGATE', {
              linkText: goldCardInfo?.name,
              linkUrl: goldCardInfo?.href,
            });
          }}
          href={goldCardInfo?.href}
        >
          {goldCardInfo?.name}
        </Link>
      </Alert>
    </StyledAlert>
  );
};
